import { LoadingController } from 'ionic-angular';
import { Row } from "../../../api/index";
import { CalculationService } from "../../calculation/calculation-service";
import { Action } from './action';

export class ActionRowMarkGreen implements Action {

    protected cssClass = 'bit-row-mark-green';

    constructor(
        protected calculationService: CalculationService,
        protected loadingController: LoadingController
    ) {}

    trigger(row:Row) : Promise<boolean> {
        let loading = this.loadingController.create({
            content: 'Zeilenmarkierung wird geändert...'
        });

        return new Promise<boolean>((resolve, reject) => {
            loading.present();
            
            setTimeout(() => {
                this.calculationService.editRow(this.toggleClass(row))
                    .then(() => {
                        loading.dismiss();
                        resolve(false);
                    });
            }, 500);            
        });        
    }

    toggleClass(row:Row) {
        if (row.style && typeof row.style == 'string' && row.style.indexOf(this.cssClass) >= 0) {
            row.style = row.style.replace(this.cssClass, '').replace('  ',' ');
        } else {
            row.style = this.cssClass;
        }
        return row;
    }

}


// WEBPACK FOOTER //
// ./src/services/row-action/action/action-row-mark-green.ts